<template lang="html">
  <div class="home">
     <!-- <keep-alive> -->
        <router-view/>
      <!-- </keep-alive> -->
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss" scoped>
.home {
  background-color: #f0f0f0;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
